import { env } from '@/services/dev';
import utils from '@/services/tools';
import http from '@/services/http';
import { channel } from '@/pages/work-wx/services/channel-service';

export default {
  // 获取所有可用国家列表
  getAvailableCountryList() {
    return http
      .wwxPost(`${env.apiBase}/wwx/visa_country_available_brief_query`, {
        channel,
      })
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  // 往下是国家页调用的接口
  getCountryInfo(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/visa_country_query`, { ...params, channel })
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  getProductList(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/visa_product_brief_query`, {
        ...params,
        channel,
      })
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  getMaterialDetailFile(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/product_material_list`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
};
